export const permission = {
  MYMEDAX_PATIENT_QUESTIONNAIRE_UNASSIGN: 'MYMEDAX_PATIENT_QUESTIONNAIRE_UNASSIGN',
  MYMEDAX_PATIENT_QUESTIONNAIRE_ASSIGN: 'MYMEDAX_PATIENT_QUESTIONNAIRE_ASSIGN',
  MYMEDAX_PATIENT_UPDATE: 'MYMEDAX_PATIENT_UPDATE',
  MYMEDAX_PATIENT_QUESTIONNAIRE_READ: 'MYMEDAX_PATIENT_QUESTIONNAIRE_READ',
};
